import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Blog from './pages/Blog';
import SinglePost from './pages/SinglePost';
import Admin from './pages/Admin';
import Terms from './pages/Terms';
import { SettingsProvider, useSettings } from './context/SettingsContext';
import { Helmet } from 'react-helmet-async';
import './App.css';

const GlobalSEO = () => {
  const { settings } = useSettings();
  return (
    <Helmet>
      <title>{settings?.siteTitle || 'أسعار الذهب اليوم عيار 21 الآن'}</title>
      <meta name="description" content={settings?.siteDescription || 'تعرف على أسعار الذهب اليوم عيار 21 الآن في الصاغة. تحديث لحظي لسعر جرام الذهب عيار 21 و18، وسعر الجنيه الذهب. تابع أسعار الذهب الآن وتوقعات الخبراء.'} />
      <meta name="keywords" content="أسعار الذهب اليوم عيار 21 الان, أسعار الذهب اليوم عيار 21, سعر جرام الذهب عيار 21 اليوم, سعر الذهب اليوم عيار 18, سعر الجنيه الذهب, اسعار الذهب لحظة بلحظة, جرام الذهب اليوم, اسعار الذهب الان, سعر الذهب اليوم عيار 21, أسعار الذهب اليوم, سعر الذهب اليوم عيار 21 الآن, توقعات الذهب, سعر جرام الذهب عيار 21 سعر الذهب اليوم, اسعار الذهب, توقعات سعر الذهب, توقعات أسعار الذهب" />
      <link rel="canonical" href="https://bekamdahab.com/" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://bekamdahab.com/" />
      <meta property="og:title" content={settings?.siteTitle || 'سعر الذهب اليوم عيار 21 الآن | أسعار الذهب لحظة بلحظة'} />
      <meta property="og:description" content={settings?.siteDescription || 'تعرف على أسعار الذهب اليوم عيار 21 الآن في الصاغة. تحديث لحظي لسعر جرام الذهب عيار 21 و18، وسعر الجنيه الذهب.'} />
      <meta property="og:image" content="https://bekamdahab.com/fav.png" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content="https://bekamdahab.com/" />
      <meta property="twitter:title" content={settings?.siteTitle || 'سعر الذهب اليوم عيار 21 الآن | أسعار الذهب لحظة بلحظة'} />
      <meta property="twitter:description" content={settings?.siteDescription || 'تعرف على أسعار الذهب اليوم عيار 21 الآن في الصاغة. تحديث لحظي لسعر جرام الذهب عيار 21 و18، وسعر الجنيه الذهب.'} />
      <meta property="twitter:image" content="https://bekamdahab.com/fav.png" />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "بكام الذهب",
          "url": "https://bekamdahab.com/",
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://bekamdahab.com/blog?q={search_term_string}",
            "query-input": "required name=search_term_string"
          },
          "description": settings?.siteDescription || "تعرف على أسعار الذهب اليوم عيار 21 الآن في الصاغة."
        })}
      </script>
    </Helmet>
  );
};

import About from './pages/About';

function App() {
  return (
    <HelmetProvider>
      <SettingsProvider>
        <GlobalSEO />
        <Router>
          <div className="app">
            <a href="#main-content" className="skip-link">انتقل إلى المحتوى الرئيسي</a>
            <Navbar />
            <main id="main-content" className="main-content">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/post/:slug" element={<SinglePost />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/about" element={<About />} />
              </Routes>
            </main>
            <footer className="app-footer">
              <div className="footer-content" style={{ display: 'flex', flexDirection: 'column', gap: '15px', alignItems: 'center' }}>
                <div className="footer-links" style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', justifyContent: 'center' }}>
                  <Link to="/about" style={{ color: 'var(--color-text-secondary)', textDecoration: 'none', fontSize: '0.9rem' }}>من نحن</Link>
                  <Link to="/about" style={{ color: 'var(--color-text-secondary)', textDecoration: 'none', fontSize: '0.9rem' }}>تواصل معنا</Link>
                  <Link to="/about" style={{ color: 'var(--color-text-secondary)', textDecoration: 'none', fontSize: '0.9rem' }}>سياسة الخصوصية</Link>
                  <Link to="/terms" style={{ color: 'var(--color-text-secondary)', textDecoration: 'none', fontSize: '0.9rem' }}>شروط الاستخدام</Link>
                </div>
                <p className="legal-notice" style={{ margin: 0, fontSize: '0.85rem' }}>
                  جميع الحقوق محفوظة © {new Date().getFullYear()} بكام الذهب - أسعار الذهب لحظة بلحظة.
                </p>
                <div className="trust-signals" style={{ display: 'flex', gap: '10px', opacity: '0.7' }}>
                  <span title="Verified Data Source">🛡️ مصادر موثوقة</span>
                  <span title="SSL Secured">🔒 اتصال آمن</span>
                </div>
              </div>
            </footer>
          </div>
        </Router>
      </SettingsProvider>
    </HelmetProvider>
  );
}

export default App;
